import { get, GetReturnType, post, put, remove } from "src/api/fetch";
import { Type_Filters } from "src/components/web/FilterElements";
import { getSchemaFromUrl } from "src/router/routes";
import { Type_Element } from "src/types/element";

export const createElement = (body: Partial<Type_Element>): GetReturnType => {
    if (body === null) {
        throw new Error("Invalid argument: 'body' cannot be null");
    }
    return post(body, `${VITE_API_URL}/${getSchemaFromUrl()}/elements`);
};

export const getElements = (mapId: number): GetReturnType => {
    return get(
        `${VITE_API_URL}/${getSchemaFromUrl()}/elements/maps/${mapId}/categories`,
    );
};

export const getElementsPerMap = (
    mapId: number,
    filters: Type_Filters,
): GetReturnType => {
    const { selectedCategories, startDate, endDate, search } = filters;
    let queryParams = "?";
    const DateFormat = "YYYY-MM-DD";
    if (Object.values(selectedCategories).length > 0) {
        queryParams += `&categories=${selectedCategories.join(",")}`;
    }

    if (startDate) {
        queryParams += `&start_date=${startDate.format(DateFormat)}`;
    }

    if (endDate) {
        queryParams += `&end_date=${endDate.format(DateFormat)}`;
    }

    if (search) {
        queryParams += `&search=${search}`;
    }
    return get(
        `${VITE_API_URL}/${getSchemaFromUrl()}/elements/maps/${mapId}/${queryParams}`,
    );
};

export const updateElement = (
    elementId: number,
    body: Partial<Type_Element>,
): GetReturnType => {
    if (body === null) {
        throw new Error("Invalid argument: 'body' cannot be null");
    }
    return put(
        body,
        `${VITE_API_URL}/${getSchemaFromUrl()}/elements/${elementId}`,
    );
};

export const deleteElement = (elementId: number): GetReturnType => {
    return remove(
        `${VITE_API_URL}/${getSchemaFromUrl()}/elements/${elementId}`,
    );
};

export const getDocuments = (elementId: number): GetReturnType => {
    return get(
        `${VITE_API_URL}/${getSchemaFromUrl()}/documents/element/${elementId}`,
    );
};

export const getDocumentDetails = (id: number): GetReturnType => {
    return get(`${VITE_API_URL}/${getSchemaFromUrl()}/documents/details/${id}`);
};
